import React from "react";
import TopNav from "./TopNav";

const Phonebook_head = () => (
  <header className="header-legacy pt-lg-5">
    <a href="#appBody" class="sr-only sr-only-focusable bg-white">
      Skip to main content <i class="far fa-arrow-down"></i>
    </a>
    <TopNav />
    <div className="container d-flex align-items-center justify-content-lg-between py-lg-4 py-0">
      <div className="d-flex align-items-center py-3">
        <div
          className="text-lg-left lockup-container"
          style={{ height: "auto" }}
        >
          <div id="scuLoginButton"></div>
          <h1 className="sr-only">Santa Clara University</h1>
          <h1 class="h1 text-site-name text-default">
            <a class="text-dark nameText" href="/phonebook/">
              Phonebook
            </a>
          </h1>
        </div>
      </div>
    </div>

    <nav className="navbar navbar-expand-lg navbar-dark bg-dark shadow initial nav-dark nav-custom">
      <div id="navbarMenu" className="container">
        <button
          className="navbar-toggler px-3 py-2"
          type="button"
          data-toggle="collapse"
          data-target="#navbarCustom"
          aria-controls="navbarCustom"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="text-capitalize">menu</span>
        </button>
        <div className="collapse navbar-collapse" id="navbarCustom">
          <ul className="navbar-nav mr-auto py-3 py-lg-0 w-75">
            <li className="nav-item">
              <a
                className="nav-item nav-link text-capitalize px-3"
                href="/phonebook/emergency-contacts"
              >
                Emergency Contacts
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-item nav-link text-capitalize px-3"
                href="/phonebook/Housing"
              >
                Housing
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-item nav-link text-capitalize px-3"
                href="/phonebook/print"
              >
                Print
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-item nav-link text-capitalize px-3"
                href="/phonebook/content/faq"
              >
                FAQ
              </a>
            </li>

            <li className="nav-item">
              <a className="nav-item nav-link text-capitalize px-3" href="/map">
                Campus Map
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link text-white text-capitalize px-3"
                href="https://www.scu.edu/giving/"
              >
                Giving
              </a>
            </li>
            <li className="nav-item d-lg-none">
              <div className="dropdown-divider"></div>
              <a
                className="nav-link text-capitalize px-3"
                href="https://www.scu.edu/"
              >
                SCU Home
              </a>
            </li>
            <li className="nav-item d-lg-none">
              <a
                className="nav-link text-capitalize px-3"
                href="https://www.scu.edu/services"
              >
                Offices &amp; Services
              </a>
            </li>
            <li className="nav-item d-lg-none">
              <a
                className="nav-link text-capitalize px-3"
                href="https://www.scu.edu/schools-and-centers"
              >
                Schools &amp; Centers
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </header>
);
export default Phonebook_head;

